import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import NavigateNext from '@mui/icons-material/NavigateNext';
import styles from './DraftBlock.module.scss';
import { Button } from 'tt-ui-lib/core';
import { LitterBinIcon } from 'tt-ui-lib/icons';
import RenameInput from '../ReportRename/ReportRename';
import { CALC_TYPES } from 'utils/calculatorUtils';
import Menu3Dot from '../Menu3Dot/Menu3Dot';

const DraftBlock = ({ props }) => {
  const {
    draft,
    targetWidth,
    editId,
    setEditId,
    onProceedDraft,
    onDelete,
    onRenameDraft,
    onBuyCredits,
    onGenerate,
  } = props;

  const menuItems = [
    {
      key: 'pay',
      label: 'Pay',
      onClick: () => onBuyCredits(draft.id),
      disabled: !draft.canPay,
    },
    {
      key: 'delete',
      label: 'Delete',
      onClick: () => onDelete(draft),
      disabled: !draft.canPay || !onDelete,
    },
  ];

  const getSubType = () => {
    switch (draft.type) {
      case CALC_TYPES.CARBON:
        return 'Annual';
      case CALC_TYPES.PROJECT:
        return 'Project';
      default:
        return null;
    }
  };

  const getReportPeriod = () => {
    if (!draft.periodReportDate) return null;
    switch (draft.type) {
      case CALC_TYPES.CARBON:
        return draft.periodReportDate.getFullYear();
      case CALC_TYPES.PROJECT:
        return `${draft.periodReportDate?.toLocaleDateString()}${draft.periodReportDateEnd ? `-${draft.periodReportDateEnd?.toLocaleDateString()}` : ''}`;
      default:
        return null;
    }
  };

  return (
    <div
      key={draft.id}
      className={clsx(styles.rowWrapper, targetWidth < 940 && styles.shortFormat)}
    >
      <div className={styles.summary}>
        <div className={styles.draftName}>
          <RenameInput
            id={draft.id}
            name={draft.name}
            onEditClick={() => setEditId(editId === draft.id ? null : draft.id)}
            onEditFinish={onRenameDraft}
            isEditing={editId === draft.id}
          />
          {getSubType() && <div className={styles.dataValue}>{getSubType()}</div>}
        </div>
        <div className={clsx(styles.horizontal, styles.info)}>
          <div className={clsx(styles.dataBlock, styles.vertical)}>
            <p className={clsx(styles.dataName, draft?.periodReportDate ?? styles.gray)}>
              Reporting period:
            </p>
            {draft?.periodReportDate && <p className={styles.dataValue}>{getReportPeriod()}</p>}
          </div>
          <div className={clsx(styles.dataBlock, styles.vertical)}>
            <div className={clsx(styles.container, styles.horizontal)}>
              <p className={styles.dataName}>Edited:</p>
              <p className={styles.dataValue}>
                {draft?.updatedAt ? draft.updatedAt.toLocaleDateString() : ''}
              </p>
            </div>
            <div className={clsx(styles.container, styles.horizontal)}>
              <p className={styles.dataName}>Created:</p>
              <p className={styles.dataValue}>
                {draft?.createdAt ? draft.createdAt.toLocaleDateString() : ''}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.buttonCont}>
        <div className={styles.item1}>
          {draft.canPay && (
            <Button type="default" onClick={() => onProceedDraft(draft.id)}>
              Proceed
            </Button>
          )}
          {!draft.canPay && (
            <Button type="default" onClick={() => onGenerate(draft.id)}>
              to result
            </Button>
          )}
        </div>
        <Menu3Dot items={menuItems} className={clsx(styles.menuStyle, styles.item2)} />
      </div>
    </div>
  );
};

export default DraftBlock;
